var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { appendLogCache, mallocLogCache } from './cache';
import { consoleOutput } from './console';
import { LogCacheLimit, LogMode } from './defs';
import { getLogTime, stringifyLogArgs } from './helper';
/**
 * 绑定播放器实例的日志工具，将日志字符串cache起来使用
 */
var Logger = /** @class */ (function () {
    function Logger(playerId, scopeName, logModeConfig) {
        this.playerId = playerId;
        this.scopeName = scopeName;
        if (!this.playerId) {
            throw new Error('Missing logger id');
        }
        mallocLogCache(playerId);
        // 默认仅使用log, warn, error的日志
        this.logModeConfig = __assign({ trace: LogMode.console, debug: LogMode.console, info: LogMode.console, log: LogMode.cache | LogMode.console, warn: LogMode.cache | LogMode.console, error: LogMode.cache | LogMode.console }, logModeConfig);
    }
    // 日志写入接口
    Logger.prototype.trace = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['trace'], args, false));
    };
    ;
    Logger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['debug'], args, false));
    };
    ;
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['info'], args, false));
    };
    ;
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['log'], args, false));
    };
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['warn'], args, false));
    };
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.callApi.apply(this, __spreadArray(['error'], args, false));
    };
    /**
     * 仅cache日志用于上传，不在devtools打印
     */
    Logger.prototype.cache = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var level = 'log';
        var logPrefix = this.getLogPrefix();
        this.callApiForCache.apply(this, __spreadArray([level, logPrefix], args, false));
    };
    Logger.prototype.getLogPrefix = function () {
        var _a = this, playerId = _a.playerId, scopeName = _a.scopeName;
        var logPrefix = "[".concat(playerId.slice(-8), "][").concat(getLogTime(), "]").concat(scopeName ? "[".concat(scopeName, "]") : '');
        return logPrefix;
    };
    Logger.prototype.callApi = function (level) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var logPrefix = this.getLogPrefix();
        if (this.logModeConfig[level] & LogMode.console) {
            consoleOutput.apply(void 0, __spreadArray([level, logPrefix], args, false));
        }
        this.callApiForCache.apply(this, __spreadArray([level, logPrefix], args, false));
    };
    Logger.prototype.callApiForCache = function (level, logPrefix) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (this.logModeConfig[level] & LogMode.cache) {
            var payload = "[".concat(level, "]").concat(logPrefix, " ").concat(stringifyLogArgs(args, this.getStringifyLogIgnoreKeys()));
            if (payload.length >= LogCacheLimit) {
                payload = "".concat(payload.slice(0, LogCacheLimit), "...(").concat(payload.length, ")");
            }
            this.cacheLog(payload);
        }
    };
    /**
     * 日志转字符串时候需要忽略的key列表
     */
    Logger.prototype.getStringifyLogIgnoreKeys = function () {
        return ['m3u8'];
    };
    // 慎改，外部有劫持
    Logger.prototype.cacheLog = function (payload) {
        appendLogCache(this.playerId, payload);
    };
    Object.defineProperty(Logger.prototype, "ignoreKeyList", {
        // 慎改，外部有劫持
        /**
         * 输出日志时忽略某些key值，例如加密相关敏感字端
         */
        get: function () {
            // chachaParam等关键词为了避免敏感词检索，由外部劫持后定义
            return [];
        },
        enumerable: false,
        configurable: true
    });
    /** @deprecated */
    Logger.level = 0;
    return Logger;
}());
export { Logger };
/** @deprecated 为了兼容某些插件用引入thumbplayer-core的日志函数保留空函数 */
export function logTool() { }
;
